module.exports = __webpack_public_path__ + "img/lnsy.404b5c19.png";